import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { useAuthContext } from '../../../../context/auth.context'
import { useRoleContext } from '../../../../role/role.context'
import { NoAccess } from '../../../../role/components/no-access'
import { NotFoundPage } from '../../../../page/not-found'
import { useKeyWrites } from './key-access'
import { useApiAccess } from './use-api-access'
import { ApiKeyList } from './page/api-key-list'
import { ApiKeyDetail } from './page/api-key-detail'
import { PageTrail } from '../../../../shared/sso-workspace/page-trail'
import { SECTION } from '../../../../shared/navigation/sections'

// /org/api-keys: the organization's API keys (Phase D; plan Task 15).
// /org/api-keys/:keyID is one key (tabs Overview, Usage and Requests, in
// ?tab=), and /org/api-keys/:keyID/requests/:requestLogID one request of
// its log, in a drawer over the Requests tab.
//
// The route is gated by API_KEY read, not only its sidebar entry, so a
// typed address without it says so (once the permissions have loaded)
// instead of a page whose every read is refused. Like its sidebar entry, it
// also exists only while the organization's partner API access is on (owner
// 2026-11-02): off, a typed address is not found, staff included; nothing
// shows while the access is being read.
export const LayoutApiKeys = () => {
  const { canRead } = useKeyWrites()
  const roleContext = useRoleContext()
  const { state } = useAuthContext()
  const known = !!(roleContext && roleContext.orgLoaded) || !!(state && (state.isSysAdmin || state.isSysRoot))
  const access = useApiAccess(canRead)

  return (
    <Route path="/org/api-keys" render={({ location }) => {
      if (!canRead) return known ? <NoAccess what="this organization's API keys" /> : null
      if (!access) return null
      if (access.enabled !== true) return <NotFoundPage pathname={location.pathname} />
      return (
        <Switch>
          <Route exact path="/org/api-keys"><PageTrail trail={[SECTION.apiKeys]} /><ApiKeyList /></Route>
          <Route path="/org/api-keys/:keyID(\d+)" component={ApiKeyDetail} />
          <Route render={({ location }) => <NotFoundPage pathname={location.pathname} />} />
        </Switch>
      )
    }} />
  )
}
